import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonServiceLayerService, RequestPayLoadFormat } from 'src/app/services/common-service-layer.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Config } from '../../../config/config';
import { Router, ActivatedRoute } from '@angular/router';
import { AgmMap } from '@agm/core';
import { GoogleMap } from '@agm/core/services/google-maps-types';
import { Polygon, MultiPolygon } from 'geojson';
import { AppService } from 'src/app/app.service';
import { interval, timeThursdays } from 'd3';
declare let google: any;

@Component({
  selector: 'app-map-staion-view-loader',
  templateUrl: './map-staion-view-loader.component.html',
  styleUrls: ['./map-staion-view-loader.component.scss']
})
export class MapStaionViewLoaderComponent implements OnInit {

  @ViewChild('AgmMap', { static: false }) agmMap: AgmMap;
  public map: GoogleMap;
  public Object = Object;
  public markers: any; // for showing the markers in map
  public lat :any; // To Display default latitude
  public lng :any; // To Display default longitude
  public zoom = 6;
  public fitBounds = true;
  public geoJsonObject;
  public selectedMonitoringType: any = 'All';
  public siteStatusMapping;
  public standards: any;
  public geoJson: any = {};
  public multiGeoJson: any = [];
  public inputData: any = {};
  public filterStore: any = {};
  public geoJsonLoad = false;
  public loadMultiJson = false;
  public selectedMarkerInfo: any;
  public isOpenWindow = false;
  public markerData: any;
  public tableData: any = {};
  public SelecetedSite: any = {};
  public loadTable: any = {};
  public toggleFilter = false;
  public tableConfigData: any = {};
  // public tableData: any = {};
  public errorStatusMessage;
  public infoWindowOpened;
  public previousInfoWindow;
  public timeRange;
  public pdfData: any = {
    ReportType: 'Map Data',
    startTime: this.sharedService.formatDate(new Date()) + ' 00:00:00',
    endTime: this.sharedService.formatDate(new Date()) + ' ' + this.sharedService.formatTime(new Date())
  };
  public printMetaDataChart: any = {
    reportName: 'Map Data',
    isChart: true,
    fileName: 'Map',
    headerLabel: 'label',
    headerContent: this.pdfData,
    isDropDown: true
  };
  public timeRanges = [
    { key: '1d', value: '1 Day' },
    { key: '7d', value: '7 Day' },
    { key: '30d', value: '30 Day' }
  ];
  intervel: any;
  constructor(
    public http: CommonServiceLayerService,
    public sharedService: SharedService,
    public router: Router,
    public appService: AppService
  ) { }
  ngOnInit() {
    this.siteStatusMapping = this.appService.constants.siteStatus;
    this.setTableConfig();
    // this.fetchAQIMetrics();
    this.loadMap();
    // this.pdfData.siteName = this.stationName;
    this.pdfData.startTime = this.sharedService.formatDate(new Date()) + ' 00:00:00';
    this.pdfData.endTime = this.sharedService.formatDate(new Date()) + ' ' + this.sharedService.formatTime(new Date());
    // this.loadGeoJson();
  }
  mapReady(event) {
    this.map = event as GoogleMap;
    this.lat = parseFloat(this.markers[0].latitude);
    this.lng = parseFloat(this.markers[0].longitude);
  }
  setTableConfig() {
    try {
      this.tableConfigData = {
        dtOptions: {
          maxRows: 6,
          customTableClass: 'no-class',
          searchButton: false,
          columnSearch: false,
          searchbox: false,
          displayOptions: false,
          hidePageInfo: true,
          headerLabel: 'label',
          valueBasedColor: {
            avg: 'color'
          },
          print: {
            show: false,
            isDropDown: true,
            fileName: 'Summary Dashboard',
            types: ['pdf', 'excel', 'csv'],
            printMetaData: {},
            headerLabel: 'label'
          }
        }
      };
    } catch (error) {
      Config.logger(error);
    }
  }
  loadGeoJson() {
    try {
      const request: RequestPayLoadFormat = {
        api: 'geoJSON',
        method: 'get',
        loader: true,
        type: 'JSON',
        hideErrorMessage: false
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          const responseData = response.data;
          this.geoJsonObject = responseData.geoJSON;
          this.lat = responseData.lat;
          this.lng = responseData.lng;
        } else {
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  styleFunc(feature) {
    return ({
      clickable: false,
      fillColor: feature.getProperty('fill'), // feature.getProperty('color'), '#50a3ea'
      strokeWeight: 1,
      fillOpacity: 0.7,
      stroke: '#50a3ea'
    });
  }
  loadMap() {
    const payLoad = {
      loadType: 'ui',
      siteId: localStorage.getItem('siteId')
    };
    try {
      const request: RequestPayLoadFormat = {
        api: 'geochartmapLoaderDM',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          // this.geoJsonObject = response.data.geoJson;
          setTimeout(() => {
            this.markers = response.data.siteList;
            this.lat = parseFloat(this.markers[0].latitude);
            this.lng = parseFloat(this.markers[0].longitude);
            this.markers.forEach((element, i) => {
              // this.tableData[i] = element.paramData;
              if (element.timeInterval) {
                this.filterStore = { key: element.timeInterval };
              }
              element.options = {
                color: '#FFFFF7',
                // fontWeight: '600',
                fontSize: '0.6rem',
                text: '' + element.siteName,
              };
              const icon = {
                url: '',
                scaledSize: {
                  width: 100,
                  height: 25,
                },
                // labelOrigin: { x: 30, y: 10 }
              };
              switch (element.SiteStatus) {
                case 'In-Active':
                  icon.url = 'assets/images/markers/grey.png';
                  if (element.marker_icon && element.marker_icon !== 'red') {
                    icon.url = 'assets/images/red.png';
                  } else {
                    icon.url = 'assets/images/markers/grey.png';
                  }
                  break;
                case 'Active':
                  if (element.marker_icon && element.marker_icon === 'yellow') {
                    icon.url = 'assets/images/markers/green-yellow.png';
                  } else if (element.marker_icon && element.marker_icon === 'green') {
                    icon.url = 'assets/images/green.png';
                  } else {
                    icon.url = 'assets/images/markers/grey.png';
                  }
                  break;
                case 'Delay':
                  if (element.marker_icon && element.marker_icon !== 'grey') {
                    icon.url = 'assets/images/markers/grey.png';
                  } else {
                    icon.url = 'assets/images/markers/grey.png';
                  }
                  break;
                default:
                  icon.url = 'assets/images/markers/grey.png';
                  break;
              }
              element.icon = icon;
            });
          }, 200);
        } else {
          this.sharedService.serviceErrorMessage(response.message || 'Failed to load. Please try again later.');
        }
      });
    } catch (error) {
      Config.logger(error);
    }

  }
  isInfoWindowOpen(id) {
    // return this.openedWindow; // alternative: check if id is in array
  }
  clickedMarker(data, event, i) {
    // this.openedWindow = data.siteName;
    try {
      this.isOpenWindow = false;
      // if (this.previousInfoWindow == null) {
      //   this.previousInfoWindow = true;
      // } else {
      //   this.infoWindowOpened = true;
      //   this.loadTable = undefined;
      //   // this.previousInfoWindow.close();
      //   this.previousInfoWindow = false;
      // }
      this.startTimeEndTime(1);
      this.lat = undefined;
      this.lng = undefined;
      this.previousInfoWindow = false;
      this.tableConfigData.tableData = undefined;
      this.toggleFilter = true;
      this.loadTable = undefined;
      this.filterStore = { key: data.timeInterval ? data.timeInterval : '1d' };
      this.loadTable = data;
      this.pdfData.siteName = this.loadTable.siteName;
      this.geoJsonLoad = true;
      this.geoJson = data.geoJson;
      this.tableConfigData.tableData = data.paramData;
      this.multiGeoJson = [];
      this.SelecetedSite = {};
      this.SelecetedSite[i] = { key: data.siteName };
      this.loadMultiJson = false;
      // this.fitBounds = false;
      // this.lat = data.latitude;
      // this.lng = data.longitude;
      // this.zoom = 12;
      // this.fitbounds(data);
      this.previousInfoWindow = true;
    } catch (error) {
      Config.logger(error);
    };
    for (this.timeRange of this.timeRanges) {
      if (this.timeRange.key === data.timeInterval) {
        this.timeInterval(this.timeRange, data);
      }
    };
  }
  fitbounds(data) {
    const bounds = new google.maps.LatLngBounds();
    for (const feature of data.geoJson.features) {
      const geometry = feature.geometry;
      if (geometry.type === 'Polygon') {
        (feature.geometry as Polygon).coordinates.forEach(latlngs => {
          latlngs.forEach(latlng => {
            bounds.extend({ lng: latlng[0], lat: latlng[1] });
          });
        });
      } else if (geometry.type === 'MultiPolygon') {
        (feature.geometry as MultiPolygon).coordinates.forEach(polygon => {
          polygon.forEach(latlngs => {
            latlngs.forEach(latlng => {
              bounds.extend({ lng: latlng[0], lat: latlng[1] });
            });
          });
        });
      }
    }
    console.log(bounds);
    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds);
    }
  }
  showMarkerInfo(data, i) {
    // this.openedWindow = this.openedWindow.push(data.siteName);
    try {
      this.SelecetedSite = [];
      if (this.SelecetedSite[i]) {
        if (this.SelecetedSite[i].key === data.siteName) {
          if (this.multiGeoJson.length > 0) {
            this.multiGeoJson.forEach((ele, index) => {
              if (ele.name === data.siteName) {
                this.multiGeoJson.splice(index, 1);
              }
            });
            delete this.SelecetedSite[i];
          }
        } else {
          this.SelecetedSite[i] = { key: data.siteName };
          this.multiGeoJson.push({ name: data.siteName, geoJson: data.geoJson });
        }
      } else {
        this.SelecetedSite[i] = { key: data.siteName };
        this.multiGeoJson.push({ name: data.siteName, geoJson: data.geoJson });
      }
      // this.geoJsonLoad = false;
      this.loadMultiJson = true;
      if (this.previousInfoWindow) {
        // this.previousInfoWindow = infoWindow;
        // this.previousInfoWindow.close();
        this.previousInfoWindow = false;

      }
      this.fitBounds = true;
      this.lat = parseFloat(data.latitude);
      this.lng = parseFloat(data.longitude);
      this.zoom = 11;
    } catch (error) {
      Config.logger(error);
    }
    // this.clickedMarker(data, undefined, i);
    // this.geoJson = data.geoJson;
  }
  windowClose(marker) {
    try {
      this.lat = undefined;
      this.lng = undefined;
      // if (this.SelecetedSite[i]) {
      //   if (this.SelecetedSite[i].key === marker.siteName) {
      //     if (this.multiGeoJson.length > 0) {
      //       this.multiGeoJson.forEach((ele, index) => {
      //         if (ele.name === marker.siteName) {
      //           this.multiGeoJson.splice(index, 1);
      //         }
      //       });
      //       delete this.SelecetedSite[i];
      //     }
      //   }
      // }
      this.geoJsonLoad = false;
      this.geoJson = {};
      this.previousInfoWindow = false;
      // infoWindow.close();
      this.lat = marker.latitude;
      this.lng = marker.longitude;
      this.zoom = 11;
      this.fitBounds = true;
    } catch (error) {
      Config.logger(error);
    }
  }
  toggleFilterStatus(data, interval) {
    this.toggleFilter = !this.toggleFilter;
    setTimeout(() => {
      this.filterStore = { key: interval };
    }, 500);
    if (interval) {
      this.timeInterval(interval, data, true);
    }
  }
  redirectPage(marker) {
    this.router.navigate(['/landing/reports/dmAverageReport', marker.siteId]);
  }
  closePopup() {
    try {
      if (this.previousInfoWindow !== null) {
        this.previousInfoWindow = false;
        this.previousInfoWindow = null;
        this.SelecetedSite = {};
      }
      // this.lat = marker.latitude;
      // this.lng = marker.longitude;
      this.zoom = 11;
      this.fitBounds = true;
      this.geoJsonLoad = false;
      this.geoJson = {};
    } catch (error) {
      Config.logger(error);
    }
  }
  saveIntervel(marker) {
    try {
      this.inputData.timeInterval = this.filterStore.key;
      this.inputData.bodyContent = {
        siteId: marker.siteId
      };
      // saveTimeIntervel
      const request: RequestPayLoadFormat = {
        api: 'saveTimeIntervel',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad: this.inputData
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.sharedService.serviceErrorMessage(response.message);
        } else {
          this.errorStatusMessage = response.message;
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  timeInterval(intervel, marker, isFilter?) {
    if (isFilter === false) {
      this.inputData.timeIntervel = intervel;
    }
    try {
      if (isFilter) {
        this.inputData.timeInterval = intervel;
      } else {
        this.inputData.timeInterval = intervel.key;
      }
      if (this.inputData.timeInterval) {
        const interval = parseInt(this.inputData.timeInterval);
        this.startTimeEndTime(interval);
      }
      this.inputData.bodyContent = {
        siteId: marker.siteId
      };
      this.filterStore = intervel;
      this.tableConfigData.tableData = undefined;


      const request: RequestPayLoadFormat = {
        api: 'fetchDashboardDataDM',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad: this.inputData
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.loadTable.paramData = response.data.tableData;
          this.tableConfigData.tableData = marker.paramData;
        } else {
          this.errorStatusMessage = response.message;
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }

  }
  // thresholdClass(body, thead, marker) {
  //   try {
  //     // if (thead.key === 'avg') {
  //     // if (parseFloat(body.avg) > parseFloat(body.highThreshold)) {
  //     // if (marker.SiteStatus === 'Active') {
  //     //   if (body.marker_icon) {
  //     //     marker.icon.url = 'assets/images/markers/green-' + body.marker_icon + '.gif';
  //     //   }
  //     // } else if (marker.SiteStatus === 'In-Active') {
  //     //   marker.icon.url = 'assets/images/markers/red.png';
  //     // } else {
  //     //   if (body.marker_icon) {
  //     //     marker.icon.url = 'assets/images/markers/grey-' + body.marker_icon + '.gif';
  //     //   }
  //     // }
  //     // return 'inactive-background';
  //     // }
  //     // }
  //   } catch (error) {
  //     Config.logger(error);
  //   }
  //   // console.log(body);
  // }
  startTimeEndTime(timeInterval) {
    const presentDate = new Date();
    const fromDate = presentDate.setDate(presentDate.getDate() - timeInterval);
    this.pdfData.startTime = this.sharedService.formatDate(fromDate) + ' ' + '00:00:00';
    this.pdfData.endTime = this.sharedService.formatDate(new Date()) + ' ' + this.sharedService.formatTime(new Date());
  }

}
